<template>
  <div id="contents">
    <div class="recruit_welfare" >
      <div class="recruit_welfare_main move_view">
        <div class="title_area">
          <p class="title">「働きやすさ」のために</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" />
        </div>
        <p class="caption">オフの時間も大切にしながらメリハリをつけて面白いコンテンツをつくれるよう、福利厚生や働く環境を充実させています。</p>
      </div>
      <div id="recruit_welfare_section0" class="recruit_welfare_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/01.png" alt="01"></p>
        </div>
        <div class="welfare">
          <p class="title">福利厚生</p>
          <ul class="list">
            <li class="item">
              <p class="title">東京ディズニーリゾート・コーポレート利用券</p>
              <p class="text">東京ディズニーリゾートを特別料金でお得に利用できます。</p>
            </li>
            <li class="item">
              <p class="title">厚生会マイチョイス</p>
              <p class="text">1年間に一定のポイントが付与され、貯めたポイントをレジャー、エンターテイメント鑑賞、スポーツ観戦、習い事、エステなど自分の好きなことに使える、福利厚生プログラムです。</p>
            </li>
            <li class="item">
              <p class="title">保養所（リゾートホテル）</p>
              <p class="text">「東急ハーヴェストクラブ」「みやび倶楽部」のリゾートホテルをお得に利用できます。</p>
            </li>
            <li class="item">
              <p class="title">チケットレストラン加盟店 食事補助　</p>
              <p class="text">全国59,000店以上の飲食店やコンビニで毎日利用できる、食事券補助サービスです。</p>
            </li>
            <li class="item">
              <p class="title">UberEats 食事補助</p>
              <p class="text">Uber Eatsのサービス提供地域であれば利用可能です。</p>
            </li>
            <li class="item">
              <p class="title">クラブ活動補助</p>
              <p class="text">「野球部」「ゴルフ部」「ランニング部」「映像研究部」など、趣味の活動費用をサポートします。</p>
            </li>
            <li class="item">
              <p class="title">各種慶弔見舞金</p>
              <p class="text">結婚、出産、子女の入学、弔慰などの際にお渡ししています。</p>
            </li>
            <li class="item">
              <p class="title">テレビ朝日健康保険組合</p>
              <p class="text">人間ドック、「ベネフィットステーション（スポーツクラブ、映画、カラオケ、各種チケット等優待など）」をご利用いただけます。</p>
            </li>
          </ul>
        </div>
      </div>
      <div id="recruit_welfare_section1" class="recruit_welfare_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/02.png" alt="02"></p>
        </div>
        <div class="work_environment">
          <p class="title">働く環境</p>
          <ul class="list">
            <li class="item">
              <p class="title">新オフィス</p>
              <p class="text">2020年3月にリニューアルしてフリーアドレス化しました。ノートPCを配付し、自分の業務内容などに合わせて好きなエリアで仕事ができるようにしています。</p>
              <ul class="images">
                <li><img src="../assets/img/common/recruit_2021/welfare/office_1.png" alt="オフィス"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/office_2.png" alt="オフィス"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/office_3.png" alt="オフィス"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/office_4.png" alt="オフィス"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/office_5.png" alt="オフィス"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/office_6.png" alt="オフィス"></li>
                <p>Photo  by TOMOOKI KENGAKU</p>
              </ul>
            </li>
            <li class="item">
              <p class="title">iPhone貸与</p>
              <p class="text">iPhoneを従業員全員に配付。効率的に仕事ができるようにしています。</p>
            </li>
            <li class="item">
              <p class="title">外部教育講座の受講</p>
              <p class="text">人材育成及び定時退社の奨励策として、クリエイタースキルを高める外部講座の受講費用を会社で負担しています。積極的に活用してスキルアップにつなげてください。</p>
            </li>
            <li class="item">
              <p class="title">人材育成制度</p>
              <p class="text">入社後は、新入社員研修で業務の基本を学びます。その後、1、2年目はジョブローテーションでさまざまな職種、現場を体験。その他、外部講師を招いた研修などでクリエイターとして必要な能力や知見を幅広く身につけていきます。また、実力主義の給与体系・評価制度を導入しており、がんばって成果を出した分、しっかり評価される環境です。</p>
              <ul class="images">
                <li><img src="../assets/img/common/recruit_2021/welfare/teaching_1.png" alt="人材教育"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/teaching_2.png" alt="人材教育"></li>
                <li><img src="../assets/img/common/recruit_2021/welfare/teaching_3.png" alt="人材教育"></li>
              </ul>
            </li>
            <li class="item">
              <p class="title">メリハリをつけて働くための休日休暇</p>
              <p class="text">休日は、完全週休2日制（原則として土・日）。休暇として、夏季休暇（7月～11月で10連休も可）、冬季休暇（12月～3月で取得）、年末年始休暇、有給休暇、誕生日休暇、永年勤続特別休暇を整えています。また、育児介護支援制度もあるのでライフステージに応じた働き方が可能です。</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_info',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'info_layout_status',
    'request_tag_id'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    //animation
    this.$nextTick(() => {
      var secTopArr = new Array();
      var current = -1;
      $('.recruit_welfare_list').each(function (i) {
        secTopArr[i] = $(this).offset().top;
      });
      $(window).scroll(function () {
        for (var i = secTopArr.length-1; i>=0; i--) {
          if ($(window).scrollTop() > secTopArr[i] - 450) {
            if (i != current) {
              $('#recruit_welfare_section'+i).addClass('move_view');
              current = i;
              break;
            }
          }
        }
      });
    });

  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_welfare
    .title
      position: relative
      overflow: hidden
      opacity: 0
      display: inline-block
      &::before
        content: ""
        display: block
        position: absolute
        background: #fff
        top: 0
        left: -10%
        width: 120%
        height: 100%
        z-index: 50
        -webkit-transform: skewX(10deg)
        transform: skewX(10deg)
    .text,.measures_list_item,.caption
      position: relative
      overflow: hidden
      opacity: 0
      display: inline-block
      &::before
        content: ""
        display: block
        position: absolute
        background: #fff
        top: 0
        left: -10%
        width: 120%
        height: 100%
        z-index: 50
        -webkit-transform: skewX(10deg)
        transform: skewX(10deg)
    &_main
      width: 1000px
      margin: 0 auto
      margin-top: 155px
      padding-bottom: 66px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -44px
        left: 67px
      .title
        @include recruit_font(41px, 79px, 0.176em)
        color: #fff
        background: #64BC24
        padding: 0 14px 0 5px
        display: table
      .close_icon
        position: absolute
        right: 0px
        top: -62px
        img
          width: 40px
          height: 40px
      a
        color: #000
        text-decoration: none
      .caption
        @include recruit_font(16px, 28px, 3px)
        margin-top: 88px
        padding: 0 66px 0 66px
        height: 52px
        display: inline-block
    &_list
      width: 1000px
      margin: 0 auto
      margin-top: 15px
      background-color: #fff
      position: relative
      &:last-child
        margin-top: 19px
        margin-bottom: 163px
      .number_area
        position: absolute
        top: 45px
        left: -30px
        display: flex
      .number
        @include recruit_font(55px, 66px, 7px)
        color: #fff
        background: #64BC24
        padding: 0 12px 0 81px
        display: table
        position: relative
        overflow: hidden
        opacity: 0
        img
          margin-top: 9px
          width: 61px
          height: 55px

        &::before
          content: ""
          display: block
          position: absolute
          background: #fff
          top: 0
          left: -10%
          width: 120%
          height: 100%
          z-index: 50
          -webkit-transform: skewX(10deg)
          transform: skewX(10deg)
      .welfare
        padding-top: 56px
        padding-bottom: 70px
        .title
          @include recruit_font(28px, 42px, 4px)
          margin: 0 0 68px 148px
        .list
          padding: 0 56px 0px 66px
          li
            display: grid
            margin-bottom: 31px
            &:last-child
              margin-bottom: 0px
            .title
              width: 100%
              padding-left: 7px
              margin: 0 0 10px 0
              border-left: solid 8px #64BC24
              @include recruit_font(18px, 25px, 0.196em)
              color: #64BC24
            .text
              @include recruit_font(14px, 28px, 0.14em)
          img
            width: 100%
      .work_environment
        padding-top: 56px
        padding-bottom: 77px
        .title
          @include recruit_font(28px, 42px, 4px)
          margin: 0 0 68px 148px
        .list
          padding: 0 56px 0px 66px
          li
            display: grid
            margin-bottom: 44px
            &:last-child
              margin-bottom: 0px
            .title
              width: 100%
              padding-left: 7px
              margin: 0 0 10px 0
              border-left: solid 8px #64BC24
              @include recruit_font(18px, 25px, 0.196em)
              color: #64BC24
            .text
              @include recruit_font(14px, 28px, 0.14em)
            .images
              display: flex
              justify-content: space-between
              flex-wrap: wrap
              margin-top: 14px
              li
                position: relative
                width: 280px
                height: 170px
                margin: 19px 0 0 0
                img
                  position: absolute
                  top: 180px
                  opacity: 0
                  width: 100%
              p
                width: 100%
                margin-top: 10px
                @include recruit_font(10px, 14px, 0.14em)
                text-align: right
          img
            width: 100%
      .corona
        padding-top: 56px
        padding-bottom: 88px
        .title
          @include recruit_font(28px, 42px, 0.14em)
          margin: 0 0 68px 148px
        .content
          padding: 0 56px 0 66px
          .caption
            @include recruit_font(16px, 28px, 0.25em)
            margin-bottom: 50px
          .measures_list
            &_item
              position: relative
              width: 100%
              margin-bottom: 85px
              &:last-child
                margin-bottom: 0px
              &:nth-child(1)
                .measures_ttl
                  margin-bottom: 40px
                .list
                  width: 550px
                  margin-bottom: 32px
              &:nth-child(2)
                .list
                  margin-bottom: 55px
              &:nth-child(3)
                .measures_desc
                  margin-bottom: 25px
                .list
                  li
                    display: flex
                    margin-bottom: 60px
                    &:last-child
                      margin-bottom: 0
                    .text
                      padding-right: 77px
                    .img
                      padding-right: 33px
              .measures
                &_ttl
                  display: flex
                  margin-bottom: 28px
                  @include recruit_font(18px, 25px, 0.19em)
                  color: #64BC24
                  &::before
                    content: ""
                    display: inline-block
                    width: 8px
                    height: 25px
                    margin-right: 20px
                    background: #64BC24
                &_desc
                  margin-bottom: 18px
                  padding-right: 7px
                  @include recruit_font(16px, 28px, 0.14em)
              .right_img
                position: absolute
                top: 27px
                right: 8px
              .list
                li
                  position: relative
                  margin-bottom: 18px
                  padding-left: 33px
                  @include recruit_font(14px, 24px, 0.14em)
                  &::before
                    content: ""
                    position: absolute
                    top: 5px
                    left: 0
                    width: 16px
                    height: 16px
                    border-radius: 8px
                    margin-right: 17px
                    background: #64BC24
              .img_list
                display: flex
                justify-content: space-between


  .move_view
    .work_environment
      .list
        li
          .images
            li
              img
                -webkit-animation: listIn 1.6s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.8s
                animation: listIn 1.6s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.8s
                @keyframes listIn
                  0%
                    top: 180px
                    opacity: 0
                  30%
                    opacity: 1
                  100%
                    top: 0px
                    opacity: 1
    .title
      opacity: 1
      &::before
        -webkit-animation: fadein0 1.8s 1 ease forwards
        animation: fadein0 1.8s 1 ease forwards
      @keyframes fadein0
        0%
          width: 150%
          left: -12.5%
          opacity: 1
        60%
          width: 150%
          left: 150%
          opacity: 1
        100%
          width: 150%
          left: 150%
          opacity: 0
    .text,.measures_list_item,.caption
      opacity: 1
      &::before
        -webkit-animation: textfadein0 1.8s 1 ease forwards
        animation: textfadein0 1.8s 1 ease forwards
      @keyframes textfadein0
        0%
          width: 150%
          left: -12.5%
          opacity: 1
        60%
          width: 150%
          left: 150%
          opacity: 1
        100%
          width: 150%
          left: 150%
          opacity: 0
    .number
      opacity: 1
      &::before
        -webkit-animation: fadein1 1.8s 1 ease forwards
        animation: fadein1 1.8s 1 ease forwards

      @keyframes fadein1
        0%
          width: 150%
          left: -12.5%
          opacity: 1
        60%
          width: 150%
          left: 150%
          opacity: 1
        100%
          width: 150%
          left: 150%
          opacity: 0

</style>



// WEBPACK FOOTER //
// src/components/recruit_welfare.vue